import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-string-list-input',
  templateUrl: './string-list-input.component.html',
  styles: []
})
export class StringListInputComponent {
  protected readonly removeIcon = faXmark;

  @Input() label: string;
  @Input() values: string[] = [];
  @Output() valuesChange: EventEmitter<string[]> = new EventEmitter();

  currentInput = '';
  errorMessage = '';

  addItem() {
    this.values = this.values || []
    this.errorMessage = '';

    const trimmedInput = this.currentInput.trim();
    if (!trimmedInput) {
      return;
    }

    if (this.values.includes(trimmedInput)) {
      this.errorMessage = 'error.valueAlreadyPresent';
      return;
    }

    this.values.push(trimmedInput);
    this.currentInput = '';
    this.valuesChanged();
  }

  valuesChanged(): void {
    this.valuesChange.next(this.values);
  }

  removeItem(index: number) {
    this.values.splice(index, 1);
    this.valuesChanged();
  }

  onEnterPressed(event: Event) {
    event.preventDefault();
    this.addItem();
  }
}
